import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { AUDIENCES } from '../siteNav';
import { PageHero, PageShell, PlaceholderList, QuoteBand } from '../components/site/PageParts';
import ExperienceGrid from '../components/site/ExperienceGrid';
import useSeo from '../hooks/useSeo';

export default function AudiencePage() {
  const { audience } = useParams();
  const a = AUDIENCES.find((x) => x.slug === audience && x.intro);
  useSeo({
    title: a ? `Merch for ${a.name} | Pusha Teez` : '',
    description: a?.intro,
    path: a && a.to,
    image: a?.img,
    noindex: true,
  });
  if (!a) return <Navigate to={audience === 'artists-bands' ? '/artist-merch' : '/production'} replace />;
  return (
    <PageShell testid={`audience-page-${a.slug}`}>
      <PageHero eyebrow="Who we serve" title={a.name} intro={a.intro} img={a.img} />
      <PlaceholderList
        items={[
          { title: 'How we help', placeholder: `Describe what you make for ${a.name.toLowerCase()}` },
          { title: 'Typical products', placeholder: 'Products and techniques most requested — to be filled in' },
          { title: 'Minimums & turnaround', ...(a.minimums ? { text: a.minimums } : { placeholder: 'Minimum order quantity and turnaround — to be filled in' }) },
          { title: 'Featured projects', placeholder: 'Project examples — to be filled in' },
        ]}
      />
      <ExperienceGrid />
      <QuoteBand />
    </PageShell>
  );
}
